import React, { useState } from "react";
import { Link } from "react-router-dom";

function Mobileheader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="mobile-header d-lg-none">
      {/* Toggle Button (Hamburger) */}
      <div className="mobile-header-top d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
        <div className="mobile-logo">
          <Link to="/" onClick={closeMenu}>
            <img
              src="/assets/img/logo/JBY-logo-83X100.png"
              alt="JBY Logo"
              height="50"
            />
          </Link>
        </div>
        <button className="menu-toggle-btn" onClick={toggleMenu}>
          <i className={`fa-solid ${menuOpen ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </div>

      {/* Offcanvas Menu */}
      <div className={`mobile-offcanvas ${menuOpen ? "active" : ""}`}>
        <nav className="mobile-nav">
          <ul>
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/About" onClick={closeMenu}>About Us</Link></li>

            <li>
              <span>Our Services</span>
              <ul className="sub-menu">
                <li><Link to="/Employee_Training" onClick={closeMenu}>Employee Training</Link></li>
                <li><Link to="/Manpower_Sourcing" onClick={closeMenu}>Manpower Sourcing</Link></li>
                <li><Link to="/Corporate_Grooming_Programs" onClick={closeMenu}>Corporate Grooming</Link></li>
                <li><Link to="/Performance_Management" onClick={closeMenu}>Performance Management</Link></li>
                <li><Link to="/KRAs_KPIs" onClick={closeMenu}>KRAs & KPIs</Link></li>
                <li><Link to="/Company_Policy_Development" onClick={closeMenu}>Company Policy Development</Link></li>
              </ul>
            </li>
            <li>
              <span>Industry Focus</span>
              <ul className="sub-menu">
                <li><Link to="/Information-Technology">Information Technology</Link></li>
                  <li><Link to="/Pharmaceutical">Pharmaceutical Industry</Link></li>
                  <li><Link to="/NBFCs">Non-Banking Financial Companies (NBFCs)</Link></li>
                  <li><Link to="/DSA">Direct Selling Agents (DSA)</Link></li>
                   <li><Link to="/Real_State_Sector">Real Estate Sector</Link></li>
              </ul>
            </li>

            <li><Link to="/Career" onClick={closeMenu}>Careers</Link></li>

            <li>
              <span>Contact Us</span>
              <ul className="sub-menu">
                <li><Link to="/Clients_Zone" onClick={closeMenu}>Client Zone</Link></li>
                <li><Link to="/Candidate" onClick={closeMenu}>Candidate Zone</Link></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      {/* Overlay */}
      {menuOpen && <div className="mobile-overlay" onClick={closeMenu}></div>}

      {/* Inline CSS */}
      <style>{`
        .menu-toggle-btn {
          background: none;
          border: none;
          font-size: 24px;
        }

        .mobile-offcanvas {
          position: fixed;
          top: 0;
          left: -100%;
          width: 280px;
          height: 100%;
          background-color: #fff;
          overflow-y: auto;
          z-index: 1050;
          padding: 20px;
          transition: all 0.3s ease-in-out;
        }

        .mobile-offcanvas.active {
          left: 0;
        }

        .mobile-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1040;
        }

        .mobile-nav ul {
          list-style: none;
          padding-left: 0;
        }

        .mobile-nav ul li {
          margin-bottom: 10px;
        }

        .mobile-nav ul li span {
          font-weight: bold;
          display: block;
          margin-bottom: 5px;
        }

        .mobile-nav ul li ul.sub-menu {
          padding-left: 15px;
          margin-top: 5px;
        }

        .mobile-nav ul li a {
          text-decoration: none;
          color: #333;
        }

        .mobile-nav ul li a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}

export default Mobileheader;
